import { COMMON_PERMISSIONS, composePermissions } from '@/commons/permissoesGrupos';

export default [
    // Cadastro de CLT
    {
        path: '/cadastroclt',
        name: 'cadastroCLT',
        component: () => import('@/modules/rh/views/cadastros/CadastroCLTView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.RH_ONLY,
        },
        props: true
    },
    // Edição de CLT
    {
        path: '/edicaoclt/:id',
        name: 'edicaoCLT',
        component: () => import('@/modules/rh/views/cadastros/CadastroCLTView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
        props: true
    },
    // Importação de Folhas CLT em Lote
    {
        path: '/importarfolhasclt',
        name: 'importarFolhasCLT',
        component: () => import('@/modules/rh/views/cadastros/ImportarFolhasCLTView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Trocar Projeto CLT
    {
        path: '/trocarprojetoclt/:id',
        name: 'trocarProjetoCLT',
        component: () => import('@/modules/rh/views/cadastros/TrocarProjetoCLTView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
        props: true
    },
    // Lista de CLT
    {
        path: '/clts',
        name: 'listaCLT',
        component: () => import('@/modules/rh/views/listas/ListaCLTView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Detalhe de CLT
    {
        path: '/clt/:id',
        name: 'detalheCLT',
        component: () => import('@/modules/rh/views/detalhes/DetalheCLTView.vue'),
        // Coordenadores acessam pela aba de Contratos CLT do projeto que coordenam.
        meta: { requiresAuth: true, allowedRoles: composePermissions('RH', 'COORDENADOR') },
        props: true
    },
    // Lista de CBO
    {
        path: '/cbos',
        name: 'listaCBO',
        component: () => import('@/modules/rh/views/listas/ListaCBOView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Lista de Benefícios CLT
    {
        path: '/beneficiosclt',
        name: 'listaBeneficiosCLT',
        component: () => import('@/modules/rh/views/listas/ListaBeneficiosCLTView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Lista de Folha CLT
    {
        path: '/folha',
        name: 'listaFolhaCLT',
        component: () => import('@/modules/rh/views/listas/ListaFolhaCLTView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Lista de Solicitações de Pagamento de Benefício
    {
        path: '/solicitacaopagamentobeneficio',
        name: 'listaSolicitacaoPagamentoBeneficio',
        component: () => import('@/modules/rh/views/listas/ListaSolicitacoesPagamentoBeneficioView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Lista de Solicitações de Pagamento de Folha CLT
    {
        path: '/solicitacaopagamentofolha',
        name: 'listaSolicitacaoPagamentoFolha',
        component: () => import('@/modules/rh/views/listas/ListaSolicitacoesPagamentoFolhaView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Cadastro de Solicitação de Pagamento de Benefício
    {
        path: '/solicitarpagamentobeneficio',
        name: 'cadastroSolicitacaoPagamentoBeneficio',
        component: () => import('@/modules/rh/views/cadastros/CadastroSolicitacaoPagamentoBeneficioView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
        props: true
    },
    // Cadastro de Solicitação de Pagamento de Folha CLT 
    {
        path: '/solicitarpagamentofolha',
        name: 'cadastroSolicitacaoPagamentoFolha',
        component: () => import('@/modules/rh/views/cadastros/CadastroSolicitacaoPagamentoFolhaView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
        props: true
    },
    // Detalhe de Solicitação Pagamento de Benefício
    {
        path: '/solicitacao/:id/pagamentobeneficio',
        name: 'detalheSolicitacaoPagamentoBeneficio',
        component: () => import('@/modules/rh/views/detalhes/DetalheSolicitacaoPagamentoBeneficioView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_RH_ORDENADOR },
        props: true
    },
    // Detalhe de Solicitação Pagamento de Folha CLT
    {
        path: '/solicitacao/:id/pagamentofolha',
        name: 'detalheSolicitacaoPagamentoFolha',
        component: () => import('@/modules/rh/views/detalhes/DetalheSolicitacaoPagamentoFolhaView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_RH_ORDENADOR },
        props: true
    },
    // Lista de Rescisões CLT
    {
        path: '/rescisoesclt',
        name: 'listaRescisaoCLT',
        component: () => import('@/modules/rh/views/listas/ListaRescisaoCLTView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Lista de Solicitações de Pagamento de Rescisão CLT
    {
        path: '/solicitacaopagamentorescisao',
        name: 'listaSolicitacaoPagamentoRescisao',
        component: () => import('@/modules/rh/views/listas/ListaSolicitacoesPagamentoRescisaoView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
    },
    // Cadastro de Solicitação de Pagamento de Rescisão CLT
    {
        path: '/solicitarpagamentorescisao',
        name: 'cadastroSolicitacaoPagamentoRescisao',
        component: () => import('@/modules/rh/views/cadastros/CadastroSolicitacaoPagamentoRescisaoView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.RH_ONLY },
        props: true
    },
    // Detalhe de Solicitação Pagamento de Rescisão CLT
    {
        path: '/solicitacao/:id/pagamentorescisao',
        name: 'detalheSolicitacaoPagamentoRescisao',
        component: () => import('@/modules/rh/views/detalhes/DetalheSolicitacaoPagamentoRescisaoView.vue'),
        meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_RH_ORDENADOR },
        props: true
    },
]